import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScApiService } from '@sc-ui';
import { demoPeople } from '../pool.demo';

@Component({
  selector: 'app-pool-candidates',
  standalone: false,
  templateUrl: './pool-candidates.component.html',
  styleUrls: ['./pool-candidates.component.scss']
})
export class PoolCandidatesComponent implements OnInit {

  candidates: any = [];

  isLoading = true;

  // ?obfuscate shows the same demo people the activity feed reports on
  obfuscate = false;

  constructor(private api: ScApiService, private route: ActivatedRoute) {
    this.obfuscate = this.route.snapshot.queryParams['obfuscate'] != null;
  }

  ngOnInit() {

    if (this.obfuscate) {
      this.candidates = demoPeople;
      this.isLoading = false;
      return;
    }

    // the pool is the company's own, so it needs no id
    this.api.get('pool/candidates').subscribe((d: any) => {
      this.candidates = d;
      this.isLoading = false;
    });
  }

}
